import UpdateItemIssue from "../../../../components/@documents/item_issues/UpdateItemIssue";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ItemIssueUpdatePage() {

    return (
        <UpdateItemIssue 
            routeType={routeTypes.admin}
        />
    )
}